import { useLocation } from 'react-router';
export const getGroupKeyRouter = () => {
    const location = useLocation().pathname;
    return location.split('/')[2] ?? null;
};
export const getItemKeyRouter = () => {
    const location = useLocation().pathname;
    return location.split('/')[3] ?? null;
};
export const getItemKeyFromPath = (path) => {
    return path.split('/')[3] ?? null;
};
export const getItemGroupFromPath = (path) => {
    return path.split('/')[2] ?? null;
};
